var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-column-content pa-5 ma-3"},[_c('page-title',{attrs:{"title":'demo'}}),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }